/* tslint:disable */

/**
 */
export class chartEstimationData {
    dhp?: number;
    conso?: number;
    dhpMax?: number;
    consoMax?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/chart-estimation-data.ts